import { array, option, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { ProfileIdsRecord } from '../components';

export const useProfileSelection = (profileIds: ProfileIdsRecord) => {
    const selectedProfileId = useMemo(
        () =>
            pipe(
                Object.values(profileIds),
                array.map((obj) => obj.profileId),
                array.filterMap(option.fromNullable),
                array.uniq(string.Eq),
                (uniqueTargetIds) => (uniqueTargetIds.length === 1 ? uniqueTargetIds[0] : undefined)
            ),
        [profileIds]
    );

    return selectedProfileId;
};
